







import {Vue, Prop, Component} from 'vue-property-decorator';
import {toI18n} from '../../../utils/commonUtils';

@Component
export default class PageTabMenu extends Vue {
  @Prop({required: true}) private currentRoute!: string;
  private tabMenuList = [
    {menuLink: '/admin/list', menuName: this.toI18n('ADMIN_LIST_OPERATOR_ACCOUNT_MANAGEMENT')},
    {menuLink: '/admin/department', menuName: this.toI18n('ADMIN_LIST_DEPARTMENTPOSITION_MANAGEMENT')},
  ];

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  private isOn(menuLink: string): string {
    return this.currentRoute.includes(menuLink) ? 'on' : '';
  }
}
